import { PIGGY_BANK_CACHE_TAGS } from '../tags';
import { apiBaseQuery } from '../../api/services/rtkQuery/apiBaseQuery';
import { getPiggyBankQuery } from './queries';
export var piggyBankApi = apiBaseQuery.injectEndpoints({
  endpoints: function endpoints(builder) {
    return {
      getPiggyBank: builder.query(getPiggyBankQuery)
    };
  }
});
piggyBankApi.enhanceEndpoints({
  addTagTypes: PIGGY_BANK_CACHE_TAGS.piggyBankTagsArray
});
var useGetPiggyBankQuery = piggyBankApi.useGetPiggyBankQuery,
  useLazyGetPiggyBankQuery = piggyBankApi.useLazyGetPiggyBankQuery,
  getPiggyBank = piggyBankApi.endpoints.getPiggyBank;
export { useGetPiggyBankQuery, useLazyGetPiggyBankQuery, getPiggyBank };
export var usePiggyBankState = piggyBankApi.endpoints.getPiggyBank.useQueryState;
export var invalidatePiggy = function invalidatePiggy() {
  return piggyBankApi.util.invalidateTags(PIGGY_BANK_CACHE_TAGS.piggyBankTagsArray);
};